import { defineStore } from 'pinia'
import cloneDeep from 'lodash.clonedeep'

export const useCountriesStore = defineStore('countries', {
  state: () => ({
    list: [],
    presort: ['GB', 'CH', 'DE', 'DK', 'LI', 'LU', 'NL', 'NO', 'SE'],
  }),
  getters: {
    listSorted: (state) => {
      const prs = cloneDeep(state.presort).reverse()
      return cloneDeep(state.list).sort((a, b) => {
        const rs1 = prs.indexOf(a.id)
        const rs2 = prs.indexOf(b.id)
        return rs2 - rs1
      })
    },
  },
  actions: {
    setCountriesList(payload) {
      this.list = [...payload].sort((a, b) => {
        if (a.name < b.name) return -1
        if (a.name > b.name) return 1
        return 0
      })
    },
  },
})
